module.exports = {
  label: {
    mobileNumber: 'mobile number',
    enterNumber: 'Enter mobile number',
    alert: 'Your session has been expired!',
    mobileExample:"eg. 0XXXXXXXXX",
    mobileError: "Mobile number should start with 0",
    nodata:'----',
    buttons: {
      login: 'Login'
    },
    validationMessages:{
        mobileRequired:'Please enter mobile number',
         mobilenumLength:'Patient mobile number must be 10 digits long',
    }
    
  }
}